import React, {useState} from 'react';
import '../../../App.css';

function Home () {
    const [showElectricityModal, setShowElectricityModalModal] = useState(false);
    const [showRentModal, setShowRentModalModal] = useState(false);
    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };
    const electricityIcon = 
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="28" cy="28" r="28" fill="#355070"/>
            <path d="M32.7867 18.6667H32.3334V14.6667C32.3334 14.1201 31.8801 13.6667 31.3334 13.6667C30.7867 13.6667 30.3334 14.1201 30.3334 14.6667V18.6667H25.6667V14.6667C25.6667 14.1201 25.2134 13.6667 24.6667 13.6667C24.1201 13.6667 23.6667 14.1201 23.6667 14.6667V18.6667H23.2134C21.8134 18.6667 20.6667 19.8134 20.6667 21.2134V28.0001C20.6667 30.9334 22.6667 33.3334 26.0001 33.3334H27.0001V41.3334C27.0001 41.8801 27.4534 42.3334 28.0001 42.3334C28.5467 42.3334 29.0001 41.8801 29.0001 41.3334V33.3334H30.0001C33.3334 33.3334 35.3334 30.9334 35.3334 28.0001V21.2134C35.3334 19.8134 34.1867 18.6667 32.7867 18.6667Z" fill="white"/>
        </svg>
    const waterIcon = 
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="28" cy="28" r="28" fill="#96BBBB"/>
            <path d="M34.12 21.8801L20.4134 35.5868C19.7734 36.2267 18.68 36.0801 18.2934 35.2668C17.6 33.8401 17.2 32.2267 17.2 30.5334C17.1734 23.1734 24.64 16.8801 27.1734 14.9467C27.6667 14.5734 28.3334 14.5734 28.8134 14.9467C29.9734 15.8267 32.1467 17.6534 34.1867 20.0534C34.64 20.5867 34.6134 21.3867 34.12 21.8801Z" fill="white"/>
            <path d="M38.8 30.5468C38.8 36.4934 33.96 41.3334 28 41.3334C25.6134 41.3334 23.3867 40.5601 21.5867 39.2268C20.9334 38.7468 20.88 37.7868 21.4534 37.2134L34.88 23.7868C35.5067 23.1601 36.56 23.2934 36.9867 24.0668C38.08 26.0801 38.8134 28.2668 38.8 30.5468Z" fill="white"/>
        </svg>
    const rentIcon = 
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="28" cy="28" r="28" fill="#294D4A"/>
            <path d="M39.6134 22.8266V35.3733C39.6134 38.6533 36.9334 41.3333 33.6534 41.3333H22.3467C19.0667 41.3333 16.3867 38.6533 16.3867 35.3733V22.8266C16.3867 20.5466 17.6667 18.56 19.5467 17.56C20.2001 17.2133 21.0134 17.68 21.0134 18.4266C21.0134 20.5466 22.7467 22.28 24.8667 22.28H31.1334C33.2534 22.28 34.9867 20.5466 34.9867 18.4266C34.9867 17.68 35.7867 17.2133 36.4534 17.56C38.3334 18.56 39.6134 20.5466 39.6134 22.8266Z" fill="white"/>
            <path d="M31.1333 14.6667H24.8667C23.48 14.6667 22.3467 15.7867 22.3467 17.1734V18.4267C22.3467 19.8134 23.4667 20.9334 24.8533 20.9334H31.1333C32.52 20.9334 33.64 19.8134 33.64 18.4267V17.1734C33.6533 15.7867 32.52 14.6667 31.1333 14.6667Z" fill="white"/>
        </svg>
    const internetIcon = 
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="28" cy="28" r="28" fill="#841F33"/>
            <path d="M34.6667 16H21.3334C17.6534 16 14.6667 18.9867 14.6667 22.6667V24V33.3333C14.6667 37.0133 17.6534 40 21.3334 40H33.3334H34.6667C38.3467 40 41.3334 37.0133 41.3334 33.3333V22.6667C41.3334 18.9867 38.3467 16 34.6667 16ZM25.9867 34.4133C25.9467 34.4133 25.9067 34.4267 25.8534 34.4267C25.3601 34.4267 24.9334 34.0533 24.8667 33.56C24.6934 32.2 23.7067 31.2133 22.3467 31.04C21.8001 30.9733 21.4134 30.4667 21.4801 29.92C21.5467 29.3733 22.0534 28.9867 22.6001 29.0533C24.8534 29.3467 26.5601 31.0533 26.8534 33.3067C26.9201 33.84 26.5334 34.3467 25.9867 34.4133ZM30.0534 33.7333C30.0134 33.7333 29.9734 33.7467 29.9201 33.7467C29.4267 33.7467 29.0001 33.3733 28.9334 32.88C28.5201 29.7067 26.2134 27.3867 23.0267 26.9733C22.4801 26.9067 22.0934 26.4 22.1601 25.8533C22.2267 25.3067 22.7334 24.92 23.2801 24.9867C27.3867 25.52 30.3867 28.5067 30.9201 32.6267C30.9867 33.16 30.6001 33.6533 30.0534 33.7333ZM33.6534 32.5733C33.6134 32.5733 33.5734 32.5867 33.5201 32.5867C33.0267 32.5867 32.6001 32.2133 32.5334 31.72C31.9601 27.2133 28.6801 23.9333 24.1734 23.36C23.6267 23.2933 23.2401 22.7867 23.3067 22.24C23.3734 21.6933 23.8801 21.3067 24.4267 21.3733C29.8534 22.0667 33.8134 26.0267 34.5201 31.4667C34.5867 32.0133 34.2001 32.5067 33.6534 32.5733Z" fill="white"/>
        </svg>


    const transactions = [
        {
            id: 1,
            service: 0,
            date: "6 Feb 2023  7:23",
            amount: 5000
        },
        {
            id: 2,
            service: 1,
            date: "1 Feb 2023  7:23",
            amount: 11000
        },
        {
            id: 3,
            service: 2,
            date: "1 Feb 2023  7:23",
            amount: 25000
        },
        {
            id: 4,
            service: 3,
            date: "2 Feb 2023  7:23",
            amount: 50000
        },
        {
            id: 5,
            service: 2,
            date: "7 Feb 2023  7:23",
            amount: 15000
        },
    ]
    return(
        <>
            
            <div className='mt-5  container bg-white flex flex-col gap-12 px-[16px]'>
                <section>
                    <p className='text-center font-medium text-xl text-[#040116]'>Payments</p>
                </section>

                <div className='app-services flex gap-[35px] md:gap-[50px]'>
                    <div className='flex flex-col'
                    //  onClick={() =>{setShowElectricityModalModal(true)}}
                     >
                        {electricityIcon}
                        <span className='text-center pt-1'>Electricity</span>
                    </div>
                    <div className='flex flex-col'>
                        {waterIcon}
                        <span className='text-center pt-1'>Water</span>
                    </div>
                    <div className='flex flex-col'>
                        {rentIcon}
                        <span className='text-center pt-1'>Rent</span>
                    </div>
                    <div className='flex flex-col'>
                        {internetIcon}
                        <span className='text-center pt-1'>Internet</span>
                    </div>
                </div>

                {/* Upcoming */}
                <div>
                    <p className='text-[#434148] text-base font-bold'>Upcoming</p>

                    <div className='pt-6 gap-2 flex flex-col'>
                        <div className='flex p-2 bg-[#F5F5F5] rounded-xl justify-between flex-row'>
                            <div className='flex flex-row'>
                                {waterIcon}
                                <div className='flex flex-col pl-4 justify-center'>
                                    <p className='p-0 font-bold'>Water bill</p>
                                    <p className='font-medium text-xs p-[2px]'>Due in 3 days</p>
                                </div>
                            </div>

                            <p className='text-[#53BC7D] font-bold text-base flex items-center'>Pay Now</p>

                        </div>

                        <div className='flex p-2 bg-[#F5F5F5] rounded-xl justify-between flex-row'>
                            <div className='flex flex-row'>
                                {electricityIcon}
                                <div className='flex flex-col pl-4 justify-center'>
                                    <p className='p-0 font-bold'>Electricity</p>
                                    <p className='font-medium text-xs p-[2px]'>Due in 4 days</p>
                                </div>
                            </div>

                            <p className='text-[#53BC7D] font-bold text-base flex items-center'>Pay Now</p>

                        </div>

                        <div className='flex p-2 bg-[#F5F5F5] rounded-xl justify-between flex-row'>
                            <div className='flex flex-row'>
                                {rentIcon}
                                <div className='flex flex-col pl-4 justify-center'>
                                    <p className='p-0 font-bold'>Rent</p>
                                    <p className='font-medium text-xs p-[2px]'>Due in 5 days</p>
                                </div>
                            </div>

                            <p className='text-[#53BC7D] font-bold text-base flex items-center'>Pay Now</p>

                        </div>
                    </div>

                </div>


                {/* Transactions */}
                <div>
                    <p className='text-[#434148] text-base font-bold'>Transactions</p>

                    <div className='pt-6 gap-2 flex flex-col'>
                        {
                            transactions.length > 0 ? 
                            (
                                transactions.map((singleTransaction) => (
                                    <div key={singleTransaction.id} className='flex p-2 bg-[#F5F5F5] rounded-xl justify-between flex-row'>
                                        <div className='flex flex-row'>
                                            {/* {waterIcon} */}
                                            {(singleTransaction.service === 0) && electricityIcon}
                                            {(singleTransaction.service === 1) && waterIcon}
                                            {(singleTransaction.service === 2) && rentIcon}
                                            {(singleTransaction.service === 3) && internetIcon}
                                            <div className='flex flex-col pl-4 justify-center'>
                                                <p className='p-0 font-bold'>
                                                    {(singleTransaction.service === 0) && "Electricity"}
                                                    {(singleTransaction.service === 1) && "Water"}
                                                    {(singleTransaction.service === 2) && "Rent"}
                                                    {(singleTransaction.service === 3) && "Internet"}
                                                </p>
                                                <p className='font-medium text-xs p-[2px]'>{singleTransaction.date}</p>
                                            </div>
                                        </div>

                                        <p className='text-[#434148] font-bold text-base flex items-center '>N {singleTransaction.amount.toLocaleString()}</p>
                                    </div>
                                ))
                            ) : ("No Transaction Available")
                        }
                    </div>

                </div>
                
                {
                    showElectricityModal &&
                    <div className='fixed top-0 bottom-0 left-0 right-0 overflow-y-auto z-[900] bg-[#ccc] flex flex-col justify-between'>
                        <div className='h-[50px]'></div>
                        <div className='scroll-screen bg-white w-full h-[582px] flex flex-col phone:px-4 phone:py-6 md:py-20 md:px-[100px] lg:px-[300px] z-[9000]'>
                            <div className='flex'>
                                <span className='absolute top-4 right-4 lg:top-16 lg:right-20 bg-[#E0E0E0] rounded-full p-4 text-lg w-[40px] h-[40px] flex justify-center items-center cursor-pointer' onClick={() =>{showElectricityModal(false)}}>
                                    X
                                </span>
                                
                            </div>

                            <form className="w-full">
                                <p className='text-md cg font-bold text-[#0B1911] pb-14 text-left'>Tell us what you’re looking for</p>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full md:w-1/2 px-3 mb-0 md:mb-6">
                                    <label className="block  tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                        Full Name
                                    </label>
                                    <input className="appearance-none block w-full bg-[#F2F2F2] rounded-xl text-gray-700 border-2 border-[#828282] py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white h-12" id="grid-first-name" type="text" placeholder="Enter your name" />
                                    
                                    </div>
                                    <div className="w-full md:w-1/2 px-3">
                                    <label className="block  tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-email">
                                        Email
                                    </label>
                                    <input className="appearance-none block w-full bg-[#F2F2F2] rounded-xl text-gray-700 border-2 border-[#828282] py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12" id="grid-email" type="email" placeholder="Enter your email" />
                                    </div>
                                </div>
                                <a className='block w-[103px] h-12 rounded-xl bg-[#64E296] text-[#214B32] text-center py-[12px] text-base' onClick={() =>{ 
                                    console.log("lol"); 
                                }}>Submit</a>
                            </form>
                        </div>
                    </div> 
                }
                
                
            </div>
        </>
    );
    
}

export default Home;